import { useDeviceStore } from '../store/device';

export function IncomingCallModal() {
  const incoming = useDeviceStore(s => s.incomingCall);
  const setIncoming = useDeviceStore(s => s.setIncoming);

  if (!incoming) return null;

  const params = incoming.parameters as Record<string, string>;
  const from = params.From ?? params.from ?? 'Unknown caller';

  function accept() {
    if (!incoming) return;
    incoming.accept();
    // store.setActive happens in the device 'accept' handler in useDevice
  }

  function decline() {
    if (!incoming) return;
    incoming.reject();
    setIncoming(undefined);
  }

  return (
    <div className="fixed inset-0 bg-slate-900/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-200 max-w-sm w-full p-6 text-center animate-pulse-once">
        <p className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">Incoming call</p>
        <p className="mt-3 text-2xl font-semibold text-slate-900">{formatNumber(from)}</p>
        <p className="mt-1 text-xs text-slate-500">Lumi Ride dispatch line</p>
        <div className="mt-6 grid grid-cols-2 gap-3">
          <button
            onClick={decline}
            className="rounded-lg border border-slate-300 bg-white text-slate-700 py-2.5 text-sm font-medium hover:bg-slate-50"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="rounded-lg bg-emerald-600 text-white py-2.5 text-sm font-medium hover:bg-emerald-700"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

function formatNumber(raw: string): string {
  // Best-effort E.164 -> "+61 4XX XXX XXX" / "+1 (NPA) NXX-XXXX" etc.
  if (raw.startsWith('+61') && raw.length === 12) {
    return `${raw.slice(0, 3)} ${raw.slice(3, 6)} ${raw.slice(6, 9)} ${raw.slice(9)}`;
  }
  if (raw.startsWith('+1') && raw.length === 12) {
    return `${raw.slice(0, 2)} (${raw.slice(2, 5)}) ${raw.slice(5, 8)}-${raw.slice(8)}`;
  }
  return raw;
}
